import { gql } from '@apollo/client';

const getHuman = gql`
  query getHuman {
    web {
      userSession {
        human {
          full_name
          customer_uuid
          email
          first_name
          opendoor_internal_access
          primary_phone
          token
          organizations {
            uuid
            name
          }
        }
      }
    }
  }
`;

export default getHuman;
